<template>
	<employee-compliance :employeeId="employeeId" />
</template>

<script>
    import EmployeeCompliance from '@/components/compliance/EmployeeCompliance';

	export default {
        components: {
            EmployeeCompliance
        },
        props: {
            employeeId: {
                type: String,
                required: true
            }
        }
	};
</script>

<style></style>
